import { Intl } from '../../../general/enums';
import { t } from 'i18next';

export const alertMsg = () => {
  return {
    nodtryk: t('gsm.alert.nodtryk'),
    alarm: t('gsm.alert.alarm'),
    binder_mangel: t('gsm.alert.needs_binder'),
    noedtryk: t('gsm.alert.noedtryk'),
    termo_fejl: t('gsm.alert.termo_error'),
    vand_mangel: t('gsm.alert.needs_water'),
  } as const;
};

export function getAlerts(data: (keyof ReturnType<typeof alertMsg>)[] = []): string[] {
  const alerts = alertMsg();

  return data?.map((k) => alerts[k]) || [];
}
